import React from 'react';
import { PageHeader } from 'antd';
import history from '@utils/history';

import { UserForm } from '@containers/users';

function CreateUserPage() {
  return (
    <div className="users main-page">
      <PageHeader
        title="New User"
        style={{
          border: '1px solid rgb(235, 237, 240)'
        }}
        onBack={() => history.goBack()}
      />
      <div className="main-content">
        <UserForm />
      </div>
    </div>
  );
}

export default CreateUserPage;
